/**
 * <s-wishlist-button data-handle="…" data-label-add="…" data-label-remove="…" data-added="…" data-removed="…">
 *   <button type="button" aria-pressed="false">icon</button>
 * </s-wishlist-button>
 *
 * Toggles the product in the browser wishlist (@theme/wishlist-store). [data-active] on the host
 * drives the saved look (config/styles.css). Clicks never reach the card link underneath.
 */
import { hasInWishlist, toggleWishlist, subscribeWishlist } from "@theme/wishlist-store";
import { announceGlobalLiveRegion } from "@theme/live-region";

class SWishlistButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button");
    this.handle = this.dataset.handle;
    if (!this.button || !this.handle) return;

    this.controller = new AbortController();
    const { signal } = this.controller;

    this.button.addEventListener("click", (event) => this.onClick(event), { signal });
    subscribeWishlist(() => this.sync(), signal);
    this.sync();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const saved = toggleWishlist(this.handle);
    const message = saved ? this.dataset.added : this.dataset.removed;
    if (message) announceGlobalLiveRegion(message);
  }

  sync() {
    const saved = hasInWishlist(this.handle);
    this.toggleAttribute("data-active", saved);
    this.button.setAttribute("aria-pressed", String(saved));
    const label = saved ? this.dataset.labelRemove : this.dataset.labelAdd;
    if (label) this.button.setAttribute("aria-label", label);
  }
}

if (!customElements.get("s-wishlist-button")) {
  customElements.define("s-wishlist-button", SWishlistButton);
}
